import React, { useState, useRef } from 'react'

const OtpInput = ({ length = 4, onChangeOtp, wrapperClass }) => {
  const [otp, setOtp] = useState(Array(length).fill(''))
  const inputsRef = useRef([])

  const focusInput = index => {
    if (inputsRef.current[index]) {
      inputsRef.current[index].focus()
    }
  }

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, '')
    if (!value) return

    const newOtp = [...otp]
    newOtp[index] = value[0]

    setOtp(newOtp)

    // move forward
    if (index < length - 1) {
      focusInput(index + 1)
    }

    // callback when filled
    if (newOtp.every(val => val !== '')) {
      onChangeOtp && onChangeOtp(newOtp.join(''))
    }
  }

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      e.preventDefault()

      const newOtp = [...otp]

      if (newOtp[index]) {
        newOtp[index] = ''
        setOtp(newOtp)
      } else if (index > 0) {
        focusInput(index - 1)
        newOtp[index - 1] = ''
        setOtp(newOtp)
      }
    }

    // arrow navigation
    if (e.key === 'ArrowLeft' && index > 0) {
      focusInput(index - 1)
    }
    if (e.key === 'ArrowRight' && index < length - 1) {
      focusInput(index + 1)
    }
  }

  const handlePaste = e => {
    e.preventDefault()
    const pasteData = e.clipboardData.getData('text').replace(/\D/g, '')

    if (!pasteData) return

    const newOtp = [...otp]
    for (let i = 0; i < length; i++) {
      newOtp[i] = pasteData[i] || ''
    }

    setOtp(newOtp)

    // focus last filled
    const lastIndex = Math.min(pasteData.length - 1, length - 1)
    focusInput(lastIndex)

    if (pasteData.length >= length) {
      onChangeOtp && onChangeOtp(newOtp.join(''))
    }
  }

  return (
    <>
      {otp.map((digit, index) => {
        const inputField = (
          <input
            key={index}
            className='form-control'
            ref={el => (inputsRef.current[index] = el)}
            value={digit}
            onChange={e => handleChange(e, index)}
            onKeyDown={e => handleKeyDown(e, index)}
            onPaste={handlePaste}
            maxLength={1}
            inputMode="numeric"
            pattern="[0-9]*"
          />
        )

        return wrapperClass ? (
          <div key={index} className={wrapperClass}>
            {inputField}
          </div>
        ) : (
          inputField
        )
      })}
    </>
  )
}

export default OtpInput